import type { ValorantRank } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { ValorantRankIcon } from '@/features/games/valorant/components/valorantRankIcon';
import { getRankLabel } from '@/features/games/valorant/utils/rank';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsGameplayRankProps extends HTMLAttributes<HTMLDivElement> {
  currentRank?: ValorantRank;
  peakRank?: ValorantRank;
}

export const ProfileDetailsGameplayRank = memo(
  function ProfileDetailsGameplayRank(props: ProfileDetailsGameplayRankProps) {
    const { currentRank, peakRank, ...rest } = props;

    return (
      <Card variant="data" {...rest}>
        <p className="text-sm leading-5 font-bold">Rank</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-1">
            <ValorantRankIcon rank={currentRank} className="size-11" />
            <div className="text-cold-300 flex flex-col gap-1 text-xs leading-[1] font-medium">
              <p>Current</p>
              <p>{getRankLabel(currentRank)}</p>
            </div>
          </div>

          <div className="flex items-center gap-1">
            <ValorantRankIcon rank={peakRank} className="size-11" />
            <div className="text-cold-300 flex flex-col gap-1 text-xs leading-[1] font-medium">
              <p>Peak (90d)</p>
              <p>{getRankLabel(peakRank)}</p>
            </div>
          </div>
        </div>
      </Card>
    );
  },
);
